import React, {useEffect, useState} from "react";
import './Info.scss'
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";

let img_top = require("../../assets/Contatti.jpg");

function Company() {

    return (
        <div style={{backgroundColor: "#fafafa"}} className={"container-info"}>
            <Header/>
            <div className="video-section">
                <img className="background-video" src={img_top}/>
                <div className="overlay-content background">
                    <div>
                        <div className={"container"}>
                            <div style={{flex: 1}}>
                                <h1 className="title">Contattaci</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={"container company mt-4 mb-4"}>
                <div className={"row align-items-center justify-content-center align-items-center"}>
                    <div className={"col-md-6"}>
                        <Form>
                            <Form.Group className="mb-3" controlId="nickname">
                                <Form.Label>Nome completo</Form.Label>
                                <Form.Control type="text" placeholder="Inserisci il nome"/>
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label>Email</Form.Label>
                                <Form.Control type="email" placeholder="Inserisci l'email"/>
                            </Form.Group>
                            <Form.Group className="mb-3" controlId="message">
                                <Form.Label>Messaggio</Form.Label>
                                <Form.Control type="text" placeholder="Inserisci il messaggio" as="textarea"
                                />
                            </Form.Group>
                            <div className={"d-flex align-items-center justify-content-center align-items-center"}>
                                <Button className="btn-orange" type="submit">Invia</Button>
                            </div>
                        </Form>
                    </div>
                </div>
            </div>
            <Footer/>
        </div>
    );
}

export default Company;